import {lazy} from './lang.js';
import {t_len} from './tlist.js';
import {uuid} from 'uuidv4';

export const fig = (f) => {
    return (...args) => {
        let le = t_len(f, 0.5)(...args);
        let _f = [... lazy(f, ...args)];
        let id = uuid();
        
        for (let i=0; i < _f.length; i++) {
            _f[i] = {
                ... _f[i], figure: le, nth: i, figureId: id
            };
        }
        
    return _f;
  };
};

export const t_transform_fig = (pattern, fig, fn) => {
  return (...args) => {
    let _pattern = lazy(pattern, ...args);
    let _fig = lazy(fig, ...args);
    
    let last = undefined;
    let transformed = [];
    let figure = [];
    let nth = 0;
    for (let term of _pattern) {
      if (nth === _fig) {
        figure.push(term);
      } else {
        transformed.push(term);
      }
      if (last && term.figureId !== last.figureId) {
        if (nth === _fig) {
            let x = fn(figure);
            if (typeof x === "function") {
                x = x(...args);
            }
            transformed = [... transformed, ...x];
          figure = [];
        }
        nth++;
      }
      last = term;
    }
    if (figure.length > 0) {
        let x = fn(figure);
        if (typeof x === "function") {
            x = x(...args);
        }
      transformed = [... transformed, ... x];
    }
    
    return transformed;
  }
};
